export default "skymp5-front/3cd913091acd4077c4d1fee28f43395a.mp3";